// Bridge from Cordova's URL-open callback to a DOM event.
//
// cordova-ios ships CDVHandleOpenURL: whenever the app is opened with a URL (custom scheme
// registered via CFBundleURLTypes in mobileApp/scripts/lib/mobile-app.js) it evaluates
//   document.addEventListener('deviceready', function(){ if (typeof handleOpenURL === 'function') handleOpenURL("<url>"); })
// in the current WebView page. The hosted app loads cordova.js (template-prod.html), whose
// deviceready channel is sticky, so the callback runs immediately on a warm return. Vipps
// returns with <scheme>://vipps-return/<paymentUuid>; vippsGeneric.js listens for the event.
// Android has no equivalent callback; there the visibilitychange handlers do the work.
export const NATIVE_OPEN_URL_EVENT = 'nativeopenurl';

export function installNativeDeepLinkBridge(win = typeof window !== 'undefined' ? window : undefined) {
    if (!win || typeof win.handleOpenURL === 'function') {
        return false;
    }
    win.handleOpenURL = (url) => {
        if (typeof url !== 'string' || !url) {
            return;
        }
        try {
            win.dispatchEvent(new win.CustomEvent(NATIVE_OPEN_URL_EVENT, { detail: { url } }));
        } catch (err) {
            console.error('[nativeDeepLink] Could not dispatch open url event', err);
        }
    };
    return true;
}
